import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useOfferingCategories } from '@/data/offeringCategory';

import NotFound from '@/components/common/NotFound';
import OfferingCategoryRow from './OfferingCategoryRow';

const OfferingCategoryList = () => {
  const offeringCategories = useOfferingCategories();

  if (offeringCategories.data.length === 0) {
    return <NotFound title="No Offering Categories Found" />;
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Label</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {offeringCategories.data.map((category) => (
              <OfferingCategoryRow key={category.id} category={category} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {offeringCategories.data.length}
        </span>
      </div>
    </>
  );
};

export default OfferingCategoryList;
